import { BaseModel, attr } from "../../lib/itn-ui-kit/data";

/**
 * Contact-type field options as the Client Detail header needs them: unflattened, so
 * `additionalAttributes` survives (the `flat=true` serializer drops it).
 *
 * Separate from `FieldOptionModel` for the same reason as `ClientDetailContactModel` —
 * the parent route would otherwise race the Contacts tab over the `field-option` store
 * slot, and hand it records with no `value`, blanking out the tab's Type column.
 */
export default class ClientDetailContactTypeModel extends BaseModel {
  static urlPath = "field_options";

  @attr("string") key;
  @attr("number") order;
  @attr("json") additionalAttributes;
}
